import {ChangeTrackingService} from './changeTracking.service';

let appModule = angular.module('deliveryCreate.app');
appModule.service('ChangeTrackingService', ChangeTrackingService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/changeTracking/bootstrap.ts
 **/